import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

export const StyledButtonSecondary = withStyles(theme => ({
    root: {
        backgroundColor: theme.palette.buttonSecondary.main,
        color: theme.palette.buttonSecondary.contrastText,
        border: `solid 1px ${theme.palette.button.main}`,
        padding: "5px 25px",

        '&:hover': {
            backgroundColor: theme.palette.buttonSecondary.hover,
        }
    },
    label: {
        textTransform: 'none',
    }
}))(Button);

export default StyledButtonSecondary;